import { useMutation, useQueryClient } from '@tanstack/react-query';

import { assertReviewedQuoteIsCurrent } from '~/pages/LERE/HeatmapSurcharge/approval';

import HeatmapSurchargeService from '~/services/HeatmapSurchargeService';

import { HeatmapSurchargeApproval } from '~/types/heatmapSurcharge';

import { heatmapSurchargeQueryKeys } from './heatmapSurchargeQueryKeys';

export function useApproveHeatmapSurcharge() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (approval: HeatmapSurchargeApproval) => {
      const filters = { roomTypeId: approval.roomTypeId, checkInMonth: approval.checkInMonth };
      const latest = await queryClient.fetchQuery({
        queryKey: heatmapSurchargeQueryKeys.calendar(approval.offerId, filters),
        queryFn: ({ signal }) => HeatmapSurchargeService.getCalendar(approval.offerId, filters, { signal }),
        staleTime: 0,
      });
      assertReviewedQuoteIsCurrent(approval, latest);
      return HeatmapSurchargeService.approve(
        approval.offerId,
        approval.roomTypeId,
        approval.quote.travelDate,
        approval.note,
      );
    },
    retry: false,
    onSettled: () => queryClient.invalidateQueries({ queryKey: heatmapSurchargeQueryKeys.calendars() }),
  });
}
